import React from 'react'
import "../../CSS/Blog/Phishing.css"
import fbhack from "../../Projects/Blog/Facebook Hack.zip"
import FooTer from "../../Template/footer"
// import { CommentSection } from 'react-comments-section'
// import 'react-comments-section/dist/index.css'
// import {
//     FacebookShareButton,
// } from "react-share";
// import ProgressBar from "react-scroll-progress-bar";


export default function Phishing() {
   
    return (
        <>
            <div id='mainPhi'>
                <h1 id="start">How FB Phishing Works!</h1>
                <hr />
                <p className="hd">In This Video The Full Phishing Discusses(Using FB Phishing Site)</p>
                <div className="phishing-yt">
                    <iframe id="yt" src="https://www.youtube.com/embed/_aurJFy4ipM" title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
                </div>
                <div className="yt-visit">
                    <p id="sub">
                        If You Guys Injoy My Video So Visit My Youtube Channel:
                    </p>
                    <a id="cd" href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg" target="_blank" rel="noreferrer"><button>Code Arindam</button></a>
                </div>
                <div>
                    <p className="ans">
                        In This Video Using: <br />
                        <br />
                        1) Node JS<br />
                        2) PUG Template Engine<br />
                        3) Mongo DB<br />
                        4) Express JS<br />
                    </p>
                    <p className="q">
                        What Is Phishing?
                    </p>
                    <p className="ans">
                        Phishing is a type of cybersecurity attack during which malicious actors send messages pretending to be a
                        trusted person or entity.
                    </p>
                    <p className="q">
                        Phishing Awarness!
                    </p>
                    <p className="ans">
                        So Guys now a days phishing attackers are greater as much your throught so be carefull for Phishing sites and
                        also don't click any types of unwanted links or phishing ads links or winnerzone links or not giveing any types of case sensetive data in any website. Be Care Full, That's all about for today.
                    </p>
                </div>
                <div>
                    <p className="q">
                        :: DOWNLOAD THE FULL ZIP FILE OF FB Phishing Site ::
                    </p>
                </div>
                <div className="zip-downloader">
                    <button id="zip"><a href={fbhack}>DOWNLOAD</a></button>
                </div>
                <div>
                    <p className="last">
                        So Hope You Guys Injoy This Video And So Be Carefull And Stay Helthy And Have A Great Day...
                    </p>
                </div>
            </div>
            <FooTer />
        </>
    )
}
